/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsMegaMenu = {
  mobileChevronHtml: '<span class="close-dropdown idas-mobile-menu__chevron" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M8.12503 3.9585L13.2834 9.11683C13.5174 9.3512 13.6489 9.66891 13.6489 10.0002C13.6489 10.3314 13.5174 10.6491 13.2834 10.8835L8.12503 16.0418" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>',
  setupMobileMegaMenuParent: function($parentMobileElement) {
    const $firstLevel = $parentMobileElement.find('.mobile-menu__first-level');
    const $input = $firstLevel.find('.submenu__input');
    const $label = $firstLevel.find('.submenu__label');
    const $link = $label.length ? $label.find('> a').first() : $firstLevel.find('> a').first();
    const parentHandle = $parentMobileElement.data('mobile-menu-navlink-handle') || 'mega-menu';
    const inputId = 'mobile-submenu-mega-' + parentHandle;

    if (!$input.length) {
      $firstLevel.prepend('<input class="visually-hidden submenu__input" type="checkbox" id="' + inputId + '">');
    }

    if (!$label.length && $link.length) {
      $link.wrap('<label class="submenu__label" for="' + inputId + '"></label>');
    } else if ($label.length && $input.length) {
      $label.attr('for', $input.attr('id'));
    }

    const $resolvedLabel = $firstLevel.find('.submenu__label');
    const $resolvedLink = $resolvedLabel.find('> a').first();

    $firstLevel.removeClass('has-no-submenu').addClass('has-submenu');
    $resolvedLink.removeAttr('href').attr('role', 'button').addClass('mobile-menu-link');

    if (!$resolvedLabel.find('.idas-mobile-menu__chevron').length) {
      $resolvedLabel.append(window.PXUTheme.jsMegaMenu.mobileChevronHtml);
    }

    $firstLevel.attr('data-mobile-menu-has-toggle', true);
  },
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsMegaMenu = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    const parentLink = this.parent_link;
    const sectionId = this.section_id;
    const $megaMenuSection = $section.find('.mega-menu__' + sectionId);
    const $megaMenuInner = $megaMenuSection.find('> .mega-menu').first();
    const $parentElement = $('.header__menu [data-navlink-handle="' + parentLink + '"], .sticky-header__menu [data-navlink-handle="' + parentLink + '"]');
    const $parentElementLink = $parentElement.find('.header__link');
    // Remove old mega menus
    $parentElement.find('.mega-menu__section').remove();

    // Mobile Selectors
    const $parentMobileElement = $(`[data-mobile-menu-navlink-handle="${parentLink}"]`);

    /* No submenu is present - add mega menu elements and caret */
    if ($parentMobileElement.find('.has-no-submenu').length) {

      const $firstLevel = $parentMobileElement.find('.mobile-menu__first-level');
      const parentHandle = $parentMobileElement.data('mobile-menu-navlink-handle') || parentLink;
      const inputId = 'mobile-submenu-mega-' + parentHandle;

      if (!$firstLevel.find('.submenu__input').length) {
        $firstLevel.prepend('<input class="visually-hidden submenu__input" type="checkbox" id="' + inputId + '">');
      }

      window.PXUTheme.jsMegaMenu.setupMobileMegaMenuParent($parentMobileElement);

      // Insert placeholder ul for megamenu
      if (!$parentMobileElement.find('.has-mega-menu').length) {
        $firstLevel.find('.submenu__label').after('<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>');
      }

      // Insert mega menu
      let $parentList = $parentMobileElement.find('.has-mega-menu');
      $megaMenuInner.clone().appendTo($parentList);

    } else {
      /* Submenu is present - add mega menu elements and remove current sub-menu */
      let $parentList = $parentMobileElement.find('[data-mobile-submenu-first-level-list]');

      $parentList
        .empty()
        .addClass('has-mega-menu')
        .removeClass('has-dropdown');

      // Insert mega menu
      $megaMenuInner.clone().appendTo($parentList);
      window.PXUTheme.jsMegaMenu.setupMobileMegaMenuParent($parentMobileElement);
    }


    // Desktop
    if ($parentElement.hasClass('header__item') || $parentElement.hasClass('vertical-header__first-level')) {
      // Hide default dropdown
      $parentElement.find('.navbar-dropdown').addClass('is-invisible is-hidden');

      // Add arrow to parent link to indicate dropdown
      $parentElementLink.removeClass('is-arrowless');

      $megaMenuSection.clone().appendTo('.vertical-header__first-level[data-navlink-handle="' + parentLink + '"], .header__item[data-navlink-handle="' + parentLink + '"]');

      // Add/remove classes for proper styling and append mega menu instance
      $parentElement.addClass('has-mega-menu')
    }

    // Determine if header is set to hover to open or click to open
    if ($('.dropdown-click--false').length > 0) {
      $('.navbar-item, .header__brand, .header__search').on('mouseover', function(){

        //Close any mega menus on hover
        $('.mega-menu__section').removeClass('is-active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
        }
      })

      $('.mega-menu__section, .navbar').on('mouseleave', function(){

        //Hide mega menu upon leaving mega menu, logo or navbar
        $('.mega-menu__section').removeClass('is-active');
      })
    } else {
      $('.navbar-item, .header__brand, .header__search').on('click touchstart', function(){

        //Close any mega menus on click
        $('.mega-menu__section').removeClass('is-active');

        if($(this).hasClass('has-mega-menu')) {

          //Toggle corresponding mega menu
          $(this).find('.mega-menu__section').addClass('is-active');
        }
      })
    }
  },
  showThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
  },
  hideThemeEditorState: function(id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
  },
  displayMenu: function(id) {
    $('.mega-menu').removeClass('mega-menu--show');
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');
  },
  hideMenu: function(id) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
  },
  unload: function($section) {
    let parentLink = $section.find('.mega-menu').data('parent-link');
    let navLink = $('[data-navlink-handle="' + parentLink + '"]')
    navLink.off();
    navLink.find('.mega-menu__section').remove();
    $(`[data-mobile-menu-navlink-handle="${parentLink}"] .submenu__label`).off('click.megaMenuMobile');
    $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
  }
}

/******/ })()
;